import uuid from 'uuid-random';
import { addPopupAction, LAYER } from 'js/components/common/PopupManager';

import { PinVerificationPopup } from '../PinVerificationPopup';

const popupId = uuid();

export const showPinVerificationPopupAction = (data = {}) => addPopupAction({
    id: popupId,
    layer: LAYER.SESSION_VALIDATION,
    component: PinVerificationPopup,
    ...data
});
